import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { BUSINESS } from "@/lib/constants";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/services", label: "Services" },
  { to: "/skip-bins", label: "Skip Bins" },
  { to: "/landscaping", label: "Landscaping" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/partner", label: "Partner With Us" },
  { to: "/about", label: "About" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className="sticky top-0 z-40 bg-concrete/95 backdrop-blur border-b border-border">
      <div className="rs-container flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="nav-brand" className="flex items-center gap-3">
          <img src="/logo.png" alt="Site Cleanup" className="h-10 md:h-12 w-auto" />
          <span className="sr-only">Site Cleanup</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm font-semibold uppercase tracking-wider transition-colors ${isActive ? "text-safety" : "text-asphalt hover:text-safety"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <Link to="/request-quote" data-testid="nav-cta" className="rs-btn-primary text-sm px-5 py-2.5">Get a free quote</Link>
        </div>
        <button
          data-testid="nav-menu-toggle"
          className="md:hidden p-2 text-asphalt"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border bg-white">
          <div className="rs-container py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} className="py-2 font-semibold uppercase tracking-wider text-sm text-asphalt">
                {l.label}
              </NavLink>
            ))}
            <a href={`mailto:${BUSINESS.email}`} className="py-2 text-sm text-asphalt">Email {BUSINESS.email}</a>
            <Link to="/request-quote" className="rs-btn-primary text-sm mt-2">Get a free quote</Link>
          </div>
        </div>
      )}
    </header>
  );
}
